import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'

import { Box, Icon, useClassNames, zIndex } from '@factorialco/deprecated-design-system'
import { EnvironmentContext } from 'config/environment'

import Popover from 'modules/core/components/Popover'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import FirstSteps from 'modules/onboarding/components/FirstSteps'
import useHubspotVariables from 'modules/onboarding/hooks/useHubspotVariables'

import CallPageModal from '../CallPageModal'
import HubspotModal from '../HelpBox/HubspotModal'
import WidgetSidepanel from '../HelpWidget/WidgetSidepanel'
import PopoverContent from './PopoverContent'
import * as styles from './index.vanilla.css'
import { ModalStates } from './types'

const HelpButton = () => {
  const cx = useClassNames(styles)
  const { showOnboardingFirstSteps } = React.useContext(EnvironmentContext)
  const { pathname } = useLocation()
  const { company } = useCurrentSession()
  const { shouldShowPopover } = useHubspotVariables()
  const [modalStates, setModalStates] = useState({
    isPopoverOpen: false,
    isWidgetOpen: false,
    isCallPageModalOpen: false,
    isHSModalOpen: false,
    isChatOpen: false,
    isMeetingOpen: false,
  })

  const eventPayload = {
    page_path: pathname,
    page_url: window.location.href,
    form_number_of_employees: company.numberEmployees,
  }

  const handleStateChange = (state: Partial<ModalStates>) => {
    setModalStates((prevState) => ({
      ...prevState,
      ...state,
    }))
  }

  const handleButtonOnClick = () => {
    if (shouldShowPopover) {
      handleStateChange({ isPopoverOpen: !modalStates.isPopoverOpen })
    } else {
      handleStateChange({ isWidgetOpen: !modalStates.isWidgetOpen })
      track(trackingEvents.onboarding.openHelpWidget, eventPayload)
    }
  }

  const handleCloseButton = () => {
    if (modalStates.isWidgetOpen) {
      track(trackingEvents.onboarding.closeHelpWidget, eventPayload)
    }
    handleStateChange({ isPopoverOpen: false, isWidgetOpen: false })
  }

  const handleOpenWidget = () => {
    handleStateChange({ isPopoverOpen: false, isWidgetOpen: true })
    track(trackingEvents.onboarding.openHelpWidget, eventPayload)
  }

  return (
    <>
      {showOnboardingFirstSteps && <FirstSteps />}
      <Box
        gap="s16"
        style={{
          position: 'fixed',
          bottom: '60px',
          right: '38px',
          zIndex: zIndex.sidepanel,
        }}
      >
        <Popover
          attachment="bottom right"
          offset="0 -8px"
          className={cx('popover')}
          open={modalStates.isPopoverOpen}
          size="big"
          toggle={() => handleButtonOnClick}
        >
          <Box
            background="grey800"
            width="s32"
            height="s32"
            justifyContent="center"
            alignItems="center"
            cursor="pointer"
            borderRadius={{
              all: 'abs100',
            }}
            style={{
              bottom: '18px',
              right: '21px',
              position: 'fixed',
              display: modalStates.isWidgetOpen ? 'none' : 'flex',
            }}
          >
            <Icon.Medium icon="question" color="grey000White" />
          </Box>
          <PopoverContent
            handleOpenWidget={handleOpenWidget}
            handleStateChange={handleStateChange}
          />
        </Popover>
      </Box>
      <WidgetSidepanel open={modalStates.isWidgetOpen} onClose={handleCloseButton} />
      {modalStates.isCallPageModalOpen && (
        <CallPageModal onClose={() => handleStateChange({ isCallPageModalOpen: false })} />
      )}
      {modalStates.isHSModalOpen && (
        <HubspotModal
          isChatOpen={modalStates.isChatOpen}
          isMeetingOpen={modalStates.isMeetingOpen}
          onClose={() => {
            handleStateChange({ isChatOpen: false })
            handleStateChange({ isMeetingOpen: false })
            handleStateChange({ isHSModalOpen: false })
          }}
        />
      )}
    </>
  )
}

export default HelpButton
